import { a as _defineProperty, c as _objectWithoutProperties, _ as _objectSpread2, r as resetFocus, t as transition } from '../../dist/transitions-0e124def.esm.js';
import _mergeDeepRight from 'ramda/src/mergeDeepRight';
import { cssVar } from '@chakra-ui/theme-tools';
import { iconSizes } from '@hover/blueprint-theme';
import '@hover/utilities';
import 'ramda/src/values';
import 'ramda/src/mapObjIndexed';
import 'ramda/src/map';
import 'ramda/src/mergeDeepWith';
import { s as sizes$2 } from '../../dist/sizes-24de9207.esm.js';
import '@hover/tokens-typography';
import { s as sizes$1, f as field, v as variants } from '../../dist/menu-e502995b.esm.js';
import 'ramda/src/max';
import 'ramda/src/reduce';
import '@chakra-ui/react';
import 'polished';
import 'ramda/src/pick';

var _excluded = ["iconBefore"];
var _field, _field2, _field3;
var $fieldPaddingLeft = /*#__PURE__*/cssVar('field-padding-left');
var sizes = /*#__PURE__*/_mergeDeepRight(sizes$1, {
  "default": {
    clearButton: {
      width: 300,
      height: 300
    },
    controls: {
      width: 400,
      height: 400,
      mr: 200
    },
    field: (_field = {}, /*#__PURE__*/_defineProperty(_field, $fieldPaddingLeft.variable, sizes$2[400]), /*#__PURE__*/_defineProperty(_field, "paddingRight", sizes$2[400]), _field),
    icon: {
      width: 400,
      height: 400,
      svg: iconSizes.small
    },
    toggleButton: {
      width: 300,
      height: 300
    }
  },
  small: {
    clearButton: {
      width: 200,
      height: 200,
      svg: {
        m: 50
      }
    },
    controls: {
      width: 300,
      height: 300,
      mr: 100
    },
    field: (_field2 = {}, /*#__PURE__*/_defineProperty(_field2, $fieldPaddingLeft.variable, sizes$2[300]), /*#__PURE__*/_defineProperty(_field2, "paddingRight", sizes$2[300]), _field2),
    icon: {
      width: 300,
      height: 300,
      svg: iconSizes.small
    },
    toggleButton: {
      width: 200,
      height: 200,
      svg: {
        m: 100
      }
    }
  },
  tiny: {
    clearButton: {
      width: 100,
      height: 100,
      svg: {
        m: 0
      }
    },
    controls: {
      width: 200,
      height: 200,
      mr: 100
    },
    field: (_field3 = {}, /*#__PURE__*/_defineProperty(_field3, $fieldPaddingLeft.variable, sizes$2[200]), /*#__PURE__*/_defineProperty(_field3, "paddingRight", sizes$2[200]), _field3),
    icon: {
      width: 200,
      height: 200,
      svg: iconSizes.tiny
    },
    toggleButton: {
      width: 100,
      height: 100,
      svg: {
        m: 50
      }
    }
  }
});
var Dropdown = {
  defaultProps: {
    size: 'default'
  },
  parts: ['body', 'button', 'clearButton', 'controls', 'field', 'icon', 'item', 'list', 'loading', 'selectedItem', 'toggleButton'],
  baseStyle: function baseStyle(_ref) {
    var iconBefore = _ref.iconBefore,
      props = _objectWithoutProperties(_ref, _excluded);
    var colors = props.theme.colors;
    var baseField = field(props);
    return {
      clearButton: _objectSpread2(_objectSpread2(_objectSpread2({
        borderRadius: 300,
        border: 'none',
        background: 'transparent',
        color: 'neutral.600',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0
      }, transition.easing250('background', 'color')), resetFocus(colors.softColorFor('neutral'))), {}, {
        _hover: colors.softColorFor('neutral'),
        _groupInvalid: _objectSpread2(_objectSpread2({
          color: 'danger.600'
        }, resetFocus(colors.softColorFor('danger'))), {}, {
          _hover: colors.softColorFor('danger')
        })
      }),
      toggleButton: {
        flexShrink: 0,
        color: 'neutral.700'
      },
      controls: {
        boxSizing: 'border-box',
        position: 'absolute',
        bottom: '-1px',
        right: '-1px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'end'
      },
      selectedItem: {
        cursor: 'default'
      },
      field: _objectSpread2(_objectSpread2({}, baseField), {}, {
        position: 'relative',
        display: 'inline-flex',
        direction: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        flex: 1,
        paddingLeft: iconBefore ? "".concat($fieldPaddingLeft.reference, " !important") : undefined
      }),
      loading: {},
      icon: {
        boxSizing: 'border-box',
        position: 'absolute',
        bottom: '-1px',
        left: '-1px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'neutral.500',
        _groupFocus: {
          color: 'primary.900'
        },
        _groupInvalid: {
          color: 'danger.600'
        }
      },
      input: _objectSpread2({
        border: 'none',
        color: 'inherit',
        fontSize: 'inherit',
        lineHeight: 'inherit',
        width: '100%',
        _placeholder: {
          color: 'neutral.400',
          opacity: 1
        }
      }, resetFocus()),
      list: {
        padding: 0
      },
      body: {
        paddingX: 0,
        paddingY: 200,
        maxHeight: 750,
        overflowY: 'scroll'
      },
      item: _objectSpread2(_objectSpread2({}, variants["default"](props).item), {}, {
        '&[aria-selected=true]': {
          background: 'primary.100',
          color: 'primary.900'
        }
      })
    };
  },
  sizes: sizes,
  variants: {}
};

export { Dropdown };
